module.exports = __webpack_public_path__ + "img/options.0e527423.svg";